import Messages, { IMessage, IReference } from 'components/Messages'
import MessageComposer from './MessageComposer'
import AuthService from 'services/AuthService'
import { useMutation, useQuery } from '@tanstack/react-query'
import { fetchEventSource } from '@microsoft/fetch-event-source'
import HTTPClient from 'services/HTTPClient'
import { useEffect, useState } from 'react'
import Spinner from 'components/Spinner'
import ErrorIndicator from 'components/ErrorIndicator'


const useMessages = (room_id?: number) => {
    return useQuery({
        enabled: !!room_id,
        queryKey: ["messages", room_id],
        queryFn: async () => {
            const populate =
                "populate[0]=message&populate[1]=author&populate[2]=references&populate[3]=references.book&populate[4]=references.book.file";
            let chatMessagesResponse = await HTTPClient.get().getJSONResult(
                `/api/chat-messages?sort[0]=updatedAt:desc&filters[chat_room][id]=${room_id}&${populate}&pagination[start]=0&pagination[limit]=50`);
            console.log(chatMessagesResponse);
            let messages = chatMessagesResponse.data.map(data => {
                let author = {
                    id: data.attributes.author.data.id,
                    ...data.attributes.author.data.attributes
                }
                let references = data.attributes.references.filter(ref => ref?.book?.data).map(ref => {
                    let file = {
                        id: ref.book.data.attributes.file.data.id,
                        ...ref.book.data.attributes.file.data.attributes,
                    }
                    ref = {
                        id: ref.id,
                        page_no: ref.page_no,
                        content: ref.content,
                        book: {
                            id: ref.book.data.id,
                            page_no: ref.book.id,

                            ...ref.book.data.attributes,
                            file
                        }
                    }
                    return ref
                })
                let msg = {
                    id: data.id,
                    ...data.attributes,
                    author,
                    references
                }
                return msg
            })
            return messages.reverse();
        }
    })
}

export const useEventSourceQuery = (queryKey, onComplete) => {
    let bookID = queryKey[1]
    const [room, setRoom] = useState<any>()
    const [data, setData] = useState("")
    const [references, setReferences] = useState<IReference[] | null>(null)
    const [isInProgress, setIsInProgress] = useState(false)
    const { data: messages = [], refetch: refetchMessages, isLoading, error } = useMessages(room?.id)

    useEffect(() => {
        (async () => {
            let room = await HTTPClient.get().getJSONResult(`/api/chat-room/main?context=doc-chat`)
            setRoom(room)
        })()
    }, [])

    useEffect(() => {
        if (room?.id) {
            refetchMessages()
        }
    }, [room?.id, refetchMessages])

    useEffect(() => {
        onComplete(messages)
    }, [messages])


    useEffect(() => {
        if (!isInProgress && data && references) {
            onComplete(data, references)
            setData("")
        }
    }, [onComplete, isInProgress, data, references])


    const mutation = useMutation({
        mutationFn: async (msg: string) => {
            setReferences(null)
            setData("")
            setIsInProgress(true)
            const ctrl = new AbortController();
            fetchEventSource(`/api/chat-room/stream?book_id=${bookID}`, {
                onerror(error) {
                    console.log(error)
                    ctrl.abort()
                    setIsInProgress(false)
                    throw Error(`Error - ${error}`)
                },
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": HTTPClient.get().getAuthHeader()
                },
                body: JSON.stringify({
                    "room_id": room.id,
                    "message": msg
                }),
                signal: ctrl.signal,
                async onmessage(event) {
                    console.log(event)
                    if (event.data === "[DONE]") {
                        setIsInProgress(false)
                        refetchMessages()
                        // setData((oldData) => {
                        //     // onComplete(oldData, references)
                        //     return oldData
                        // })
                    } else {
                        setData((oldData) => oldData + event.data)
                    }
                },
            });
        },
        mutationKey: queryKey,
        retry: false,
    })
    return { data, references, isInProgress, mutate: mutation.mutate, isLoading, error }
}

const createAIMessage = (msg, references) => {
    return { message: msg, author: { id: -1, name: "", email: "" }, references }
}

const createUserMessage = (msg, references) => {
    return { message: msg, author: { id: AuthService.getUserID(), name: "", email: "" }, references }
}

export default function ChatWidget({ book_id }) {
    const [messages, setMessages] = useState<IMessage[]>([])
    let { data: typingMessage, isLoading, error, references, isInProgress, mutate } = useEventSourceQuery(["typing", book_id], (completeData) => {
        if (completeData && completeData.length) {
            console.log(`Complete - ${completeData}`)
            // let message = createAIMessage(completeData, references)
            // setMessages([...messages, message])
            setMessages(completeData)
        }
    })
    console.log("typingMessage", typingMessage, isInProgress, messages, references, isLoading, error)

    return (
        <div className="column mx-4 conversations-list h-100" style={{ overflow: "auto" }}>
            {isLoading ? <div className="center">
                <Spinner className='mt-6' />
            </div> : null}
            {error ? <ErrorIndicator error={error} /> : null}
            <Messages
                isAITyping={isInProgress}
                messages={messages}
                userID={AuthService.getUserID()}
            />
            <MessageComposer
                isInProgress={isInProgress}
                userID={AuthService.getUserID()}
                isConnected
                onSend={(msg) => {
                    console.log("Sending..")
                    let message = createUserMessage(msg, [])
                    setMessages([...messages, message])
                    mutate(msg)
                }}
            />
        </div>
    )
}